import Vue from "vue";

export const eventbus = new Vue({
    name: "eventbus",
});
